import { type ApiService } from '@Model';
import {
    FieldWithError,
    FlexRow,
    type ILinkInputProperties,
    LinkedField,
    useTranslate,
} from '@synqo/frontend-component-library';
import classes from '../ContainerSteps.module.css';

interface ContentFieldProps {
    contentField: ILinkInputProperties<ApiService>;
    /** The waste code of the chosen content, empty while none is known. */
    avvCode: string;
    /** Why "Weiter" did not go on; replaces the hint below the field. */
    error?: string;
    locked?: boolean;
}

/** The container's content, with the waste code it brings or the reason it is required below it. */
// @ai-generated 2026-10-22T16:29:04+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
export function ContentField({ contentField, avvCode, error, locked }: ContentFieldProps) {
    const i18n = useTranslate('');

    return (
        <FieldWithError error={error}>
            <LinkedField<ApiService>
                {...contentField}
                label={i18n('Inhalt / Material')}
                placeholder={i18n('Material wählen …')}
                locked={contentField.locked || locked}
            />
            {!error && (
                <FlexRow className={classes.fieldHint}>
                    {avvCode
                        ? `${i18n('Abrechnung und AVV folgen daraus')} · ${i18n('AVV')} ${avvCode}`
                        : i18n('Pflichtangabe — daraus ergeben sich Abrechnung und AVV.')}
                </FlexRow>
            )}
        </FieldWithError>
    );
}
